export default __webpack_public_path__ + "static/media/Logo_oficial.050e89c2.png";